/**
 * created by lei lei
 *最新版编辑器功能
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import E from 'wangeditor';
import {message, Modal, Button, Upload, Icon, Radio} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import UploadWall from "../../../components/upload/UploadWall";
import {ATTCHMENT_TYPE, PIC_TYPE, VIDEO_TYPE,PIC_TYPE_ORIGINAL,PIC_TYPE_WECHAT,PIC_TYPE_ORIGINAL_WECHAT} from "../../../constants";
import {connect} from "react-redux";
import {formateData, headers, headerJson, getInfoFromLocalStorage} from "../../../actions";
import $Jq from "jquery"
import {installedPlugin} from "../../../actions/weiChat";
import {applicationName} from "../../../utils";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import {uploadSetting} from "../../resource/components/resourcePool/uploadSetting";
import BaseComponent from "../../../base/BaseComponent";
import PlugInData from "../../mediaRelease/components/plug-in_data";
import {rmtMessage} from "../../mediaRelease/components/mess";
import  {DetailDialog} from"../../../view/resource/view/dialog/picture/picture"
function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

let editor = null;
const {$, BtnMenu, DropListMenu, PanelMenu, DropList, Panel, Tooltip} = E;
const postMessageDoMain = 'https://xiumi.us/';//https://
const {confirm} = Modal;

class Editors extends BaseComponent {
    static defaultProps = {
        customHeight: 630,
        imgBtnShow: false,
        xiuMiBtnShow: false,
        isUpDate: false,
        wordImportBtnShow: false,//本地 自行判断是否展示this.props.config.getValueByKey("word.Imports.And.Typesetting.Switch",0)==1?true:false;然后把状态值付给编辑器wordImportBtnShow
        editorEnable: true,
        oneTypesettingBtnShow: false,
        oneTypesettingNeedRequest: true,//是否需要请求后台
        xiuMiPlugInBtnShow: false,//下载秀米插件
        dataSourceType: 0,//代表不穿。
        btnShow135: false,//默认不展示135编辑器按钮
        wechatImgWidth:false,//微信图片宽度

        menus: [
            'image',//图片加上，是因为自定义的要借助于之歌部分功能，在下面隐藏起来
            'head',
            'bold',
            'fontSize',
            'fontName',
            'italic',
            'underline',
            'strikeThrough',
            'indent',
            'lineHeight',
            'foreColor',
            'backColor',
            'link',
            'list',
            'justify',
            'quote',
            /* 'emoticon',*/
            /* 'video',*/
            'table',
            /*'code',*/
            'splitLine',
            'undo',
            'redo',
        ]
    };
    static propTypes = {
        customHeight: PropTypes.number,//自定义编辑器高度
        imgBtnShow: PropTypes.bool,//自定义上传图片按钮是否显示
        xiuMiBtnShow: PropTypes.bool,//自定义秀米按钮是否显示为true时候 stuffId，xiuMiBtnShow，xiumiIdCallBack,title
        callBackeditorContent: PropTypes.func.isRequired,//编辑器回调函数
        content: PropTypes.string,//传递到编辑器的内容
        isUpDate: PropTypes.bool,//是否强制更新内容，和content一块使用
        stuffId: PropTypes.number,//微信当前选传参数，秀米使用关联微信的时候必须传 stuffId，xiuMiBtnShow，xiumiIdCallBack,title
        xiumiIdCallBack: PropTypes.func,//秀米使用时必传，stuffId，xiuMiBtnShow，xiumiIdCallBack,title
        title: PropTypes.string,//秀米使用时的标题，stuffId，xiuMiBtnShow，xiumiIdCallBack,title
        wordImportBtnShow: PropTypes.bool,//word导入功能按钮是否展示
        editorEnable: PropTypes.bool,//编辑器是否可操作
        btnShow135: PropTypes.bool,//135编辑器按钮是否可操作
    };

    constructor(props) {
        super(props);
        this.state = {
            content: '',
            imgVisible: false,
            fileList: [],//图片数据
            previewVisible: false,
            previewImage: '',
            oneTypesettingVisible: false,//排版的弹出框状态
            oneTypesettingContent: '',//排版的内容
            radioValue1: '/cm-sites/style/typeset/format2.css',
            radioValue2: '',
            radioValue3: '',
            goXiuMiVisible: false,//去秀米的弹出框
            imgToastStatus: true,
            type: '',
            maxSize: "",
            new: true, // 新进页面
            isUpload:false, // 更新页面
        }
    }

    componentWillMount() {
        this.state.maxSize = window.sysConfig.getValueByKey('uploadFileMaxSize', 20);
        let that = this;
        // 监听秀米页面发送的消息
        this.createPostMessage( (e) => {
            if(typeof e.data=='string'&&e.origin=='https://xiumi.us'){
                let source = e.source;
                let data = e['data'] ? JSON.parse(e['data']) : null;
                if(data) {
                    // 秀米请求调用接口并回传
                    if(data.type === 'requestAndCall') {
                        that.requestFromPostMessage(data,source)
                    }
                    // 秀米请求编辑器内容
                    if(data.type === 'xiumi') {
                        that.callXiuMiData(data,source)
                    }
                    // 秀米回显编辑器内容
                    if(data.type === 'synContent') {
                        that.getXIuMiData({
                            "xiumiId": data.xiumiId,
                            "content": data.content,
                            "type": data.type
                        })
                    }
                }
            }
        }, "Editors")
    }

    callXiuMiData = (data,source) => {
        this.plugInData.getData(this.state.content,(res)=>{
            let newdata = {
                ...res,
                ...data
            };
            this.callResByXiuMi(newdata,source);
        });
    };

    // 远端请求接口参数
    requestFromPostMessage = (message,source) => {
        let {requestReq, opener} = message;
        if(requestReq && requestReq.url) {
            let url = requestReq.url;
            let method = requestReq.method || 'get';
            let body = requestReq.body || {};
            let contentType = requestReq.contentType || "";
            this.request({
                url,method,body,contentType,
                callBack: (res) => {
                    let request = {...message,
                        requestRes: res
                    };
                    if(opener) {
                        if(opener=="xiumi") {
                            this.callResByXiuMi(request,source)
                        } else if(opener=="135") {

                        } else {

                        }
                    }
                }
            })
        }
    };

    // 给秀米回传参数
    callResByXiuMi = (request,source) => {
        if(source) {
            source.postMessage(JSON.stringify(request), "*");
            return
        }
        const { xiumiWindow } = this.state;
        if(xiumiWindow && (typeof xiumiWindow.postMessage === 'function')) {
            xiumiWindow.postMessage(JSON.stringify(request), "*");
        }
    };

    //秀米操作返回的数据填充到编辑器
    getXIuMiData = ({xiumiId, content, type}) => {
        let text = "";
        if(content && $Jq(content)) {
            text = $Jq(content).text();
        }
        this.props.callBackeditorContent && this.props.callBackeditorContent(content, text);
        this.props.xiumiIdCallBack && this.props.xiumiIdCallBack(xiumiId);
        editor.txt.clear();
        editor.txt.html(content);
        this.setState({content: content})
    };

    componentDidMount() {
        //注册监听事件，监听秀米数据来源
        let that = this;
        // if (window.addEventListener) {
        //     window.addEventListener('message', that.getXIuMiData, false);
        // } else {
        //     if (window.attachEvent) {   // IE before version 9
        //         window.attachEvent("message", that.getXIuMiData);
        //     }
        // }

        editor = new E(this._div);
        // editor = new E("#editor");

        editor.config.menus = this.props.menus;
        // 菜单 key ，各个菜单不能重复
        editor.menus.extend('xiuMI', XiuMIBtn);
        editor.goXIu = () => {
            this.request({
                url: "/cm-sites-pms/material/installedPlugin",
                callBack: (res) => {
                    let isHttps = window.location.protocol.startsWith("https");
                    if (!isHttps) {
                        message.destroy();
                        message.warn("检测到当前系统是http访问，插件功能无法正常使用");
                        return;
                    }
                    if (!res.installed) {
                        message.destroy()
                        message.warn("检测到您未安装融媒体插件，请先安装后使用！");
                        return;
                    }
                    if (!res.rightVersion) {
                        message.destroy()
                        message.warn("检测到您安装的插件不是最新版本，请重新安装后使用！");
                        return;
                    }
                    this.timeBeing();
                    // this.setState({goXiuMiVisible: true})
                }
            });


            // installedPlugin((data) => {
            //     if(data.data){
            //         let isHttps = window.location.protocol.startsWith("https");
            //         if(!isHttps){
            //             message.warn("检测到当前系统是http访问，插件功能无法正常使用");
            //             return;
            //         }
            //         //插件配置文件配置的是https 当前网站是http，那么这个肯定会提示，所以直接从上面return了
            //         if(!data.data.installed) {
            //             message.warn("检测到您未安装融媒体插件，请先安装后使用！");
            //             return;
            //         }
            //          if(!data.data.rightVersion) {
            //             message.warn("检测到您安装的插件不是最新版本，请重新安装后使用！");
            //             return;
            //         }
            //         this.setState({goXiuMiVisible: true})
            //     }
            // });
            // let that = this;
            // this.setState({goXiuMiVisible: true})
            /*  confirm({
                  title: '同时下载当前稿件？',
                 /!* content: '同时下载当前稿件？',*!/
                  cancelText:"暂时不",
                  onOk() {
                     let body={
                         title:that.props.title,
                         content:that.props.content,
                     };
                     //下载编辑器当前稿件
                      downloadCurrentMaterial(body,data=>{
                          console.log(data)
                          let blob = new Blob([data]);
                          let url = window.URL.createObjectURL(blob);
                          const link = document.createElement("a"); // 创建a标签
                          link.href = url;
                          let date = new Date();
                         link.download = that.props.title+date.getTime()+'.docx'; // 重命名文件
                          link.click();
                          URL.revokeObjectURL(url);
                      });
                      that.goXiuMi();//跳转去秀米
                  },
                  onCancel() {
                      that.goXiuMi();//跳转去秀米
                  },
              });*/


        };
        editor.menus.extend('ImgBtn', ImgBtn);
        editor.imgClick = () => {
            this.setState({imgVisible: true, fileList: []})
        };
        editor.menus.extend('WordImportBtn', WordImportBtn);
        editor.wordImportClick = () => {
            if (!this.state.content) {
                document.getElementById("upLoadWord").click();
            } else {
                confirm({
                    title: '导入word?',
                    content: '警告！导入文档会覆盖当前存在的内容，您确定要导入吗？',
                    onOk() {
                        document.getElementById("upLoadWord").click();
                    },
                    onCancel() {
                    },
                });
            }

        };
        editor.menus.extend('OneTypesettingBtn', OneTypesettingBtn);//一键排版按钮注册
        editor.oneTypesettingBtnClick = () => {
            this.setState({oneTypesettingVisible: true, oneTypesettingContent: this.state.content})
        };
        editor.menus.extend('XiuMiPlugInBtn', XiuMiPlugInBtn);//秀米插件按钮
        editor.XiuMiPlugInBtnClick = () => {
            //检测是否谷歌内核
            if (navigator.userAgent.indexOf('Chrome') >= 0) {
                window.open('/cm-sites-chrome-extension.zip');
                // getXiuMiPlugin(data => {
                //     if (data.status === 200) {
                //         window.open(data.data)
                //     }
                // })
            } else {
                message.info('检查到当前浏览器未使用chrome内核，请切换至极速模式或者直接使用谷歌浏览器。')
            }
        };
        editor.menus.extend('BtnShow135', BtnShow135);//秀米插件按钮
        editor.BtnShow135 = () => {
            window.open('https://www.135editor.com/pure_editor?callback=true&appkey=contact_135_to_get_your_appkey'+'&t='+Date.now())
        };
        if(this.props.sensitiveCheck === true) {
            editor.menus.extend('sensitiveCheck', SensitiveCheck);
            editor.onCheckSensitive = () => {
                if(typeof this.props.onCheck === "function") {
                    this.props.onCheck()
                }
            };
            editor.renderSensitiveCheck = () => {
                if(typeof this.props.renderSensitiveCheck === "function") {
                    return this.props.renderSensitiveCheck()
                }
            }
        }
        //自定义按钮
        let customBtn = [];
        if (this.props.imgBtnShow) {
            customBtn.push('ImgBtn')//添加上传图片按钮
        }
        if (this.props.sensitiveCheck) {
            customBtn.push('sensitiveCheck')//添加敏感词检测按钮
        }
        if (this.props.xiuMiBtnShow) {
            customBtn.push('xiuMI')//添加秀米对接按钮
        }
        if (this.props.wordImportBtnShow) {
            customBtn.push('WordImportBtn')//添加word导入功能
        }
        if (this.props.oneTypesettingBtnShow) {
            customBtn.push('OneTypesettingBtn')//添加一键排版功能
        }
        if (this.props.xiuMiPlugInBtnShow) {//添加秀米插件下载功能
            customBtn.push('XiuMiPlugInBtn')
        }
        if (this.props.btnShow135) {//添加135编辑器
            customBtn.push('BtnShow135')
        }

        //自定义添加图片，隐藏编辑器再带图片上传功能
        editor.config.menus = editor.config.menus.concat(...customBtn);
        editor.config.onchange = (newHtml) => {
            if(this.state.new) {
                if(newHtml ==='') {
                    this.state.isUpload = true;
                    // editor.txt.text('&nbsp');
                } else {
                    if(editor.txt.text().replace("&nbsp;","").length>0){
                        this.state.new = false;
                        this.state.isUpload = false;
                        newHtml = newHtml.replace("&nbsp;","");
                        editor.txt.text(newHtml)
                    }
                }
            }
            if (this.props.wechatImgWidth) {
                let wechatImgWidth = window.sysConfig.getValueByKey('wechat.editor.img.width', '0');
                wechatImgWidth = parseInt(wechatImgWidth);
                if (wechatImgWidth > 0) {
                    let $Dmoe = $Jq("<div>" + newHtml + "</div>");
                    let imgList = $Dmoe.find('img');
                    let flag = 0;
                    for (let i = 0; i < imgList.length; i++) {
                        var currentWidth = $(imgList[i]);
                        if (!currentWidth.attr('width')) {
                            flag++;
                            currentWidth.attr('width', wechatImgWidth)
                        }
                    }
                    if (flag > 0) {
                        editor.txt.text($Dmoe.html());
                    }
                }

            }

            this.setState({content: newHtml});
            this.props.callBackeditorContent && this.props.callBackeditorContent(this.state.isUpload?editor.txt.html().replace("&nbsp;",""):editor.txt.html(), editor.txt.text());
            console.log("editor.txt.html()",editor.txt.html());
            console.log("editor.txt.text()",editor.txt.text().trim())
        };
        editor.config.height = this.props.customHeight;//自定义编辑器的高度
        editor.config.zIndex = 500;//设置编辑器的Z-Index;防止页面功能溢出，兼容react，防止react modal至于编辑器下方。

        /**
         *
         * 一定要创建 */

        editor.create();
        this.renderCss();
        $Jq('.w-e-menu').eq(0).hide();//隐藏编辑器自带的图片
        //编辑器是否禁用可输入操作
        if (this.props.editorEnable) {
            editor.enable();
        } else {
            editor.disable();
        }
        editor.txt.clear();
        editor.txt.html("");
        // editor.config.focus = true;

        if (this.props.isUpDate) {
            let content = this.props.content;
            editor.txt.clear();
            editor.txt.html(content);
            this.setState({content})
        }
        window.wangEditor = editor;
        // 给编辑器内容打选中标记，node：要选中的dom
        // window.wangEditor.selection.getRange().setStartBefore(node)
        // window.wangEditor.selection.getRange().setEndAfter(node)
    }

    componentWillUnmount() {
        editor.destroy();
        //卸载监听
        window.removeEventListener('message', this.getXIuMiData);
        // 销毁postMessage监听
        this.destroyPostMessage("Editors")
    }

    renderCss = () => {
        document.getElementById("csspath").href = this.state.radioValue1 || this.state.radioValue2 || this.state.radioValue3;//改变css引用，
        //功能还需要增加读取主动css
    };

    componentWillReceiveProps(nextProps, nextContext) {
        let content = nextProps.content;
        if (nextProps.isUpDate) {
            editor.txt.clear();
            editor.txt.html(content);
            this.setState({content})
        }

    }

    render() {

        document.onkeypress = null;
        document.onkeydown = null;

        return (
            <div style={{width:'100%'}}>
                <div id="editor" className={'editor'} ref={(ref) => this._div = ref}></div>
                {/*继承图片编辑器*/}
                {this.renderAddIngModal()}
                {/*去秀米提示框*/}
                {this.renderGoXIuMIModal()}
                {/*图片预览*/}
               {/* {this.renderReviewImg()}*/}
                {/*上传word*/}
                {this.renderWordImport()}
                {/*一件排版*/}
                {this.renderOneTypesetting()}
                <PlugInData ref={ref=>this.plugInData=ref}/>
                <style>
                    {`
                    .w-e-text-container .placeholder{
                        color: rgba(0, 0, 0, 0.45);
                        font-size: 14px;
                        font-weight: 400;
                    }
                    .w-e-text{
                    background-color: rgba(0, 80, 179, 0.04);
                    }
                    `}
                </style>
            </div>
        )
    }

    //渲染图片上传功能
    renderAddIngModal() {
        let dataSourceType = {};
        if (this.props.dataSourceType) {
            dataSourceType = {dataSource: this.props.dataSourceType}
        }
        const {fileList} = this.state;
        return (
            <Modal
            title="添加图片"
            visible={this.state.imgVisible}
            onOk={() => this.addImgToEdit()}
            width={840}
            zIndex={1000}
            onCancel={() => {
                this.fileUploadFinish(this.state.fileList, (fileList)=> {
                    if(fileList) {
                        this.setState({imgVisible: false, fileList: []})
                    }
                    // } else {
                    //     // message.error("111")
                    //     confirm({
                    //         title: '存在未上传完毕的文件，确定关闭吗？',
                    //         onOk:()=> {
                    //             this.setState({imgVisible: false, fileList: []})
                    //         },
                    //     });
                    //
                    // }
                });
            }}
        >
            <div style={{width: 800, padding: '0 10px', height: 500}}>
                <Scrollbars
                    autoHeight
                    autoHeightMax={600}
                >
                    {/*<UploadWall*/}
                    {/*    accept={"."+PIC_TYPE.join(",.")}*/}
                    {/*    multiple={true}*/}
                    {/*    action="/storage/uploadFile"*/}
                    {/*    listType={'list'}*/}
                    {/*    fileList={fileList} // 上传文件的列表*/}
                    {/*    style={{padding:'unset'}}*/}
                    {/*    customRequest={new ChunkUpload({*/}
                    {/*        checkFileURL:"/storage/checkFile",*/}
                    {/*        checkChunkURL:"/storage/checkChunk",*/}
                    {/*        uploadChunkURL:"/storage/uploadChunk",*/}
                    {/*        chunkUploadOverURL:"/storage/chunkIsUploadOver",*/}
                    {/*        mergeChunksURL:"/storage/mergeChunk"*/}
                    {/*    }).start}*/}
                    {/*    uploadBtnName={"点击上传"}*/}
                    {/*    beforeUpload={this.beforeUpload}*/}
                    {/*    onChange={this.onChange}*/}
                    {/*    showPercent={false}*/}
                    {/*/>*/}
                    <UploadWall
                        accept={"." + PIC_TYPE_ORIGINAL_WECHAT.join(",.")}
                        multiple={true}
                        action="/dynamic/storage/uploadFile"
                        listType="picture-card"
                        fileList={fileList}
                        icons={["eye", "download", "delete"]}
                        data={dataSourceType}
                        uploadBtnName={"上传图片"}
                        onPreview={this.handlePreview}
                        onChange={this.imgHandleChange}
                        onRemove={this.handleRemove}
                        beforeUpload={(file) => {
                            let fileName = file.name.split('.');
                            let upload = fileName.at(-1).toUpperCase();
                            upload = PIC_TYPE_WECHAT.includes(upload);

                            let fileSize = file.size / 1024 / 1024; // mb
                            let beyondTheSize = fileSize > this.state.maxSize;
                            if (beyondTheSize) {
                                message.error("文件最大限制不超过" + this.state.maxSize + "M");
                            }
                            if (!upload) {
                                message.error('暂不支持该文件类型！');
                            }
                            // if(fileList.status==="uploading"){
                            //     rmtMessage.warning("正在上传，请稍等。");
                            //     return false;
                            // }
                            return new Promise((resolve, reject) => {
                                if (!upload || beyondTheSize) {
                                    reject(file);
                                } else {
                                    resolve(file);
                                }
                            });
                        }}
                        showUploadBtn={this.state.fileList.length < 8}
                        onDownload={(file) => {
                            console.log("------------------>",file)
                            let url = "/storage/downloadFile";
                            let fd = {
                                md5: file.md5,
                                download: 1
                            };
                            this.request({
                                url,
                                body: fd,
                                method: "downloadGet",
                                callBack: (fileInfo) => {

                                },
                                errorCallBack: () => {

                                },
                                serverVerify: {
                                    serverErrorCallBack: () => {

                                    }
                                }
                            });
                        }}
                    />
                    <DetailDialog ref={detailDialog=>this.detailDialog=detailDialog} path={this.state.previewImage} />
                </Scrollbars>
            </div>
        </Modal>)
    }

    //渲染去秀米的弹出框修改
    renderGoXIuMIModal() {
        return (
            <Modal
                title="提示"
                visible={this.state.goXiuMiVisible}
                onOk={() => {
                }}
                width={350}
                onCancel={this.goXIuMiCancel}
                footer={
                    <div>
                        <Button onClick={() => this.timeBeing()}>暂时不</Button>
                        <Button type="primary" onClick={() => {this.goXIuMiOK()}}>确定</Button>
                    </div>
                }
            >
                {<div>同时下载当前稿件?</div>}
            </Modal>
        )
    }

    goXIuMiCancel = e => {
        this.setState({
            goXiuMiVisible: false,
        });
    };

    //确定
    goXIuMiOK() {
        let that = this;
        this.downloadCall();
        // let body = {
        //     title: that.props.title,
        //     content: that.props.content,
        // };
        // //下载编辑器当前稿件
        // downloadCurrentMaterial(body, data => {
        //     let blob = new Blob([data]);
        //     let url = window.URL.createObjectURL(blob);
        //     const link = document.createElement("a"); // 创建a标签
        //     link.href = url;
        //     let date = new Date();
        //     link.download = that.props.title + date.getTime() + '.docx'; // 重命名文件
        //     link.click();
        //     URL.revokeObjectURL(url);
        // });
        that.goXiuMi();//跳转去秀米
        this.setState({
            goXiuMiVisible: false,
        });
    }

    //暂时不
    timeBeing() {
        this.goXiuMi();//跳转去秀米
        this.setState({
            goXiuMiVisible: false,
        });
    }

    // 下载当前文章
    downloadCall() {
        let {currentItemIndex=0, materialId} = this.props;
        if(materialId && materialId.length>1 && materialId != 'undefined' && materialId != 'null') {
            this.request({
                url: "/cm-sites-pms/material/download",
                body: {
                    materialId,
                    index: currentItemIndex+1
                },
                method: "downloadPost",
                callBack: (res) => {
                    if(res){
                        message.success("下载成功")
                    }
                },
            })
        } else {
            message.info("先保存稿件才能下载")
        }
    }

    //渲染图片预览功能
   /* renderReviewImg() {

        return (
            <Modal visible={this.state.previewVisible} footer={null} onCancel={() => {
                this.setState({previewVisible: false})
            }}
                   width={600} bodyStyle={{height: 600}}
            >
                <table cellSpacing={0} cellPadding={0} border={0} width={"100%"} height={"100%"}>
                    <tbody>
                    <tr>
                        <td align={"center"} valign={"middle"}><img style={{maxWidth: 552, maxHeight: 552}}
                                                                    alt="example" src={this.state.previewImage}/></td>
                    </tr>
                    </tbody>
                </table>
            </Modal>
        )
    }*/

    //渲染导入word 扩展按钮，隐藏显示，主动调用react 的上传组件
    renderWordImport() {
        let that = this;
        const props = {
            name: 'file',
            action: '/cm-sites-' + applicationName() + '/word/upload',
            accept: '.doc,.docx',
            showUploadList: false,
            onChange(info) {
                if (info.file.response && info.file.response.success) {
                    let params = {
                        suffix: info.file.response.storageFile.suffix,
                        path: info.file.response.url
                    };
                    getWordContent(params, data => {
                        editor.txt.clear();
                        editor.txt.html(data);
                        that.setState({connect: data});
                        let text = "";
                        if(data && $Jq(data)) {
                            text = $Jq(data).text();
                        }
                        that.props.callBackeditorContent && that.props.callBackeditorContent(data, text);
                    })
                }

            },
        };
        return (
            <div style={{display: 'none'}}>
                <Upload  {...props}>
                    <Button id={'upLoadWord'} ref={Upload => this.Upload = Upload}
                            style={{color: '#0050B3', border: 'none'}}>
                        <Icon type="upload"/>上传Word
                    </Button>
                </Upload>
            </div>

        )
    }

    //渲染一件排版
    renderOneTypesetting() {
        let screenHeight = document.body.clientHeight;
        let idName = '';
        if (this.state.radioValue1) {
            idName = this.state.radioValue1.split('format')[1].split('.')[0];
        } else if (this.state.radioValue2) {
            idName = this.state.radioValue2.split('format')[1].split('.')[0];
        } else if (this.state.radioValue3) {
            idName = this.state.radioValue3.split('format')[1].split('.')[0];
        }
        return (
            <Modal
                title="一键排版"
                visible={this.state.oneTypesettingVisible}
                onOk={this.oneTypeOK}
                onCancel={this.oneTypeCancel}
                width="80%"
            >
                <div style={{height: screenHeight * 0.6}}>
                    <div style={{height: screenHeight * 0.6 - 70, border: "2px solid #aaa"}}>
                        <Scrollbars>
                            <div id={`vsb_content_${idName}`} className='currentOneType'
                                 dangerouslySetInnerHTML={{__html: this.state.oneTypesettingContent}}>
                            </div>
                        </Scrollbars>
                    </div>

                    <div className="select_style">
                        <div>
                            <Radio.Group
                                defaultValue="/cm-sites/style/typeset/format2.css"
                                onChange={this.onChange1}
                                value={this.state.radioValue1}
                            >
                                <span style={{color: "#000"}}>常用样式</span>
                                <Radio value={'/cm-sites/style/typeset/format2.css'} style={{marginLeft: "20px"}}>
                                    默认
                                </Radio>
                                <Radio value={'/cm-sites/style/typeset/format4.css'}>大字体</Radio>
                                <Radio value={'/cm-sites/style/typeset/format500.css'}>保留更少格式</Radio>
                                <Radio value={'/cm-sites/style/typeset/format501.css'}>大字体+保留更少格式</Radio>
                            </Radio.Group>
                        </div>
                        <div>
                            <Radio.Group
                                defaultValue="1"
                                onChange={this.onChange2}
                                value={this.state.radioValue2}
                            >
                                <span style={{color: "#000"}}>通知样式</span>
                                <Radio value={'/cm-sites/style/typeset/format2.css'} style={{marginLeft: "20px"}}>
                                    默认
                                </Radio>
                                <Radio value={'/cm-sites/style/typeset/format7.css'}>大字体</Radio>
                                <Radio value={'/cm-sites/style/typeset/format502.css'}>保留更少格式</Radio>
                                <Radio value={'/cm-sites/style/typeset/format503.css'}>大字体+保留更少格式</Radio>
                            </Radio.Group>
                        </div>
                        <div>
                            <Radio.Group
                                defaultValue="1"
                                onChange={this.onChange3}
                                value={this.state.radioValue3}
                            >
                                <span style={{color: "#000", marginRight: "14px"}}>无样式</span>
                                <Radio value={'/cm-sites/style/typeset/format1.css'} style={{marginLeft: "20px"}}>
                                    默认
                                </Radio>
                            </Radio.Group>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }


    //图片类

    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            /*previewVisible: true,*/
        },()=>{
            this.detailDialog.show();
        });
    };

    imgHandleChange = ({file, fileList}) => {
        console.log(file, fileList);
        if (fileList.length > 8) {
            if (this.state.imgToastStatus) {
                message.warning('最多上传8张');
            }
            this.state.imgToastStatus = false;
            return
        } else {
            this.state.imgToastStatus = true;
        }

        fileList = fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === file.uid) {
                // console.log("-----------item.uid === file.uid-----------", item.uid, file.uid);
                if (file.response && file.response.data) {
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    file.response = {...file.response.data, ...file.response};
                }
                item.uid = file.uid;
                item.ext = file.response && file.response.suffix;
                item.url = file.response && file.response.path;
                item.name = file.response && file.response.name || file.name;
                item.isChunk = true;
                item.status = file.status;
                item.md5 = file.response && file.response.md5;

            }
            return item;
        });
        this.setState({fileList});
    };

    handleRemove = async file => {
        this.setState(prevState => {
            let fileList = prevState.fileList.filter(item => {
                return item.uid !== file.uid
            });
            return {
                fileList
            }
        });
    };

    // 文件上传完毕校验
    fileUploadFinish = (fileList,call) => {
        console.log(fileList,'fileListfileListfileListfileListfileList')
        if(this.state.fileList && this.state.fileList.length && this.state.fileList.some(item=>item.status!=="done")) {
            call&&call(false);
            return false
        }
        call&&call(fileList)
    };

    //添加图片到编辑器
    addImgToEdit() {

        this.fileUploadFinish(this.state.fileList, (fileList)=> {
            if(fileList) {
                let imgStringDome = '';
                this.state.fileList.forEach(item => {
                    imgStringDome = imgStringDome + '<p><img alt="' + item.name + '" src="' + item.url + '" style="max-width:100%;"><br></p>'
                });
                editor.cmd.do('insertHTML', imgStringDome);//图片插入到当前光标位置
                this.setState({
                    imgVisible: false,
                    fileList: [],
                })
            } else {
                message.destroy();
                message.info("存在文件未上传完成，请稍后");
            }
        });
    }

    //跳转去秀米
    async goXiuMi() {
        // 1获取需要的参数
        // let data = await this.plugInData.getData(this.state.content);
        // 2组装跳转地址
        let stuffId = 'new';
        if(this.props.stuffId && this.props.stuffId.length>1) { // 这个id应该是一个9位数
            stuffId = this.props.stuffId;
        }
        let url = `https://xiumi.us/studio/v5#/paper/for/${stuffId}/cube/0`;
        // 3跳转
        let opener = window.open(url);
        if(this.state.xiumiWindow) {
            // 4传值
            this.callXiuMiData();
            // opener.postMessage(JSON.stringify(data), "*");
        }
        this.state.xiumiWindow = opener;
        // let id = this.props.currentUser ? this.props.currentUser.id : '';
        // let params = {
        //     userId: id,
        //     content: this.state.content,
        // };
        // let url = postMessageDoMain + 'studio/v5#/paper/for/new/cube/0';
        // getXiumiUrl(this.props.stuffId, data => {
        //     if (data.status) {
        //         url = data.data;
        //     };
        //     synContent(JSON.stringify(params), data => {
        //         if (data === 'success') {
        //             let width = 1366;
        //             let height = 767;
        //             let new_url = url + '?userId=' + id;
        //             let left = (window.innerWidth - width) / 2;
        //             let top = (window.innerHeight - height) / 2;
        //             window.open(new_url, 'newindow', 'height=' + height + ',width=' + width + ',top=' + top + ',left=' + left + ',toolbar=no,menubar=no,scrollbars=no,resizable=yes,location=yes,status=yes');
        //         }
        //     })
        // })
    }

    formatContent(html) {
        html = html.replace(/(<\/[^>]*>)([^<]+)(<\/[^>]*>)/g, "$1<span>$2</span>$3").replace(/(<[^>\/]*>)([^<]+)(<[^>\/]*>)/g, "$1<span>$2</span>$3");
        var $html = $Jq.parseHTML(html);
        var list = [];

        function consoleElement(_html) {
            $Jq.each(_html, function (i, el) {
                if ($Jq(el).children().length > 0 && ($Jq(el).find("p").length > 0 || $Jq(el).find("div").length > 0 || $Jq(el).find("img").length > 0)) {
                    var children = $Jq(el).children();
                    consoleElement(children)
                } else {
                    if (el && el.outerHTML) {
                        list.push(el.outerHTML);
                        console.log("html111:" + el.outerHTML);
                    }
                }
            })
        }

        consoleElement($html);
        return list;
    }

    //一件排版操作逻辑
    // modal对话框
    oneTypeOK = (e) => {
        // console.log(e);
        let idName = '';
        if (this.state.radioValue1) {
            idName = this.state.radioValue1.split('format')[1].split('.')[0];
        } else if (this.state.radioValue2) {
            idName = this.state.radioValue2.split('format')[1].split('.')[0];
        } else if (this.state.radioValue3) {
            idName = this.state.radioValue3.split('format')[1].split('.')[0];
        }
        let id = "vsb_content_" + idName;
        let content = "<div id=" + id + ">" + this.state.oneTypesettingContent + '</div>';
        let text = "";
        if(content && $Jq(content)) {
            text = $Jq(content).text();
        }
        this.props.callBackeditorContent && this.props.callBackeditorContent(content, text);
        editor.txt.clear();
        editor.txt.html(content);
        this.setState({
            oneTypesettingVisible: false,
            content: content,
        }, () => {
            console.log(this.state.content)
        });
    };

    oneTypeCancel = (e) => {
        // console.log(e);
        this.setState({
            oneTypesettingVisible: false,
        });
    };
    //单选框
    onChange1 = (e) => {
        let oneTypesettingContent = this.state.oneTypesettingContent;
        if (this.props.oneTypesettingNeedRequest) {
            format({content: oneTypesettingContent}, (res) => {
                oneTypesettingContent = res
            })
        }
        this.setState({
            radioValue1: e.target.value,
            radioValue2: '',
            radioValue3: '',
            oneTypesettingContent
        }, () => {
            this.renderCss()
        });
    };
    onChange2 = (e) => {
        let oneTypesettingContent = this.state.oneTypesettingContent;
        if (this.props.oneTypesettingNeedRequest) {
            format({content: oneTypesettingContent}, (res) => {
                oneTypesettingContent = res
            })
        }
        this.setState({
            radioValue1: '',
            radioValue2: e.target.value,
            radioValue3: '',
            oneTypesettingContent
        }, () => {
            this.renderCss()
        });
    };
    onChange3 = (e) => {
        let oneTypesettingContent = this.state.oneTypesettingContent;
        if (this.props.oneTypesettingNeedRequest) {
            format({content: oneTypesettingContent}, (res) => {
                oneTypesettingContent = res
            })
        }
        this.setState({
            radioValue1: '',
            radioValue2: '',
            radioValue3: e.target.value,
            oneTypesettingContent
        }, () => {
            this.renderCss()
        });
    };


}

function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps)(Editors);

/*下面是自定义按钮的扩展*/
class XiuMIBtn extends BtnMenu {


    constructor(editor) {
        const $elem = E.$(
            `<div style="line-height: 40px;width: 40px;text-align: center;cursor: pointer;"><img style="width:25px;height:25px;" src="images/xiuMiIcon.png" alt=""/></div>`
        )
        super($elem, editor)
    }

    // 菜单点击事件
    clickHandler() {
        // 做任何你想做的事情
        // 可参考【常用 API】文档，来操作编辑器
        editor.goXIu();
        //alert('hello world')
    }

    // 菜单是否被激活（如果不需要，这个函数可以空着）
    // 1. 激活是什么？光标放在一段加粗、下划线的文本时，菜单栏里的 B 和 U 被激活，如下图
    // 2. 什么时候执行这个函数？每次编辑器区域的选区变化（如鼠标操作、键盘操作等），都会触发各个菜单的 tryChangeActive 函数，重新计算菜单的激活状态
    tryChangeActive() {
        // 激活菜单
        // 1. 菜单 DOM 节点会增加一个 .w-e-active 的 css class
        // 2. this.this.isActive === true
        this.active()

        // // 取消激活菜单
        // // 1. 菜单 DOM 节点会删掉 .w-e-active
        // // 2. this.this.isActive === false
        // this.unActive()
    }
}
class SensitiveCheck extends BtnMenu {
    constructor(editor) {
        const $elem = E.$(editor.renderSensitiveCheck());
        super($elem, editor)
    }

    // 菜单点击事件
    clickHandler() {
        editor.onCheckSensitive();
    }

    // 菜单是否被激活（如果不需要，这个函数可以空着）
    // 1. 激活是什么？光标放在一段加粗、下划线的文本时，菜单栏里的 B 和 U 被激活，如下图
    // 2. 什么时候执行这个函数？每次编辑器区域的选区变化（如鼠标操作、键盘操作等），都会触发各个菜单的 tryChangeActive 函数，重新计算菜单的激活状态
    tryChangeActive() {
        this.active()
    }
}

class ImgBtn extends BtnMenu {


    constructor(editor) {
        console.log(editor)
        const $elem = E.$(
            `<div style="line-height: 40px;width: 40px;text-align: center;cursor: pointer;"><img style="width:20px;height:20px;" src="images/pictureIcon.png" alt=""/></div>`
        )
        super($elem, editor)
    }

    // 菜单点击事件
    clickHandler() {
        editor.imgClick();
    }

    tryChangeActive() {
        this.active()
    }
}

class WordImportBtn extends BtnMenu {

    constructor(editor) {
        const $elem = E.$(
            `<div style="line-height: 40px;width: 70px;text-align: center;display: flex"><div style="height: 30px;line-height: 30px;margin: auto;cursor: pointer;position: relative ">
 word导入 </div></div>`
        );
        super($elem, editor)
    }

    // 菜单点击事件
    clickHandler() {
        editor.wordImportClick();
    }

    tryChangeActive() {
        this.active()
    }
}

class OneTypesettingBtn extends BtnMenu {

    constructor(editor) {
        const $elem = E.$(
            `<div style="line-height: 40px;width: 70px;text-align: center;display: flex"><div style="height: 30px;line-height: 30px;margin: auto;cursor: pointer;position: relative ">
 一键排版 </div></div>`
        );
        super($elem, editor)
    }

    // 菜单点击事件
    clickHandler() {
        editor.oneTypesettingBtnClick();
    }

    tryChangeActive() {
        this.active()
    }
}

class XiuMiPlugInBtn extends BtnMenu {

    constructor(editor) {
        const $elem = E.$(
            `<div style="line-height: 40px;width: 40px;text-align: center;cursor: pointer;"><img style="width:20px;height:20px;" src="images/plugInIcon.png" alt=""/></div>`
        );
        super($elem, editor)
    }

    // 菜单点击事件
    clickHandler() {
        editor.XiuMiPlugInBtnClick();
    }

    tryChangeActive() {
        this.active()
    }
}

class BtnShow135 extends BtnMenu {

    constructor(editor) {
        const $elem = E.$(
            `<div style="line-height: 40px;width: 40px;text-align: center;cursor: pointer;"><img style="width:20px;height:20px;" src="images/135Btn.png" alt=""/></div>`
        );
        super($elem, editor)
    }

    // 菜单点击事件
    clickHandler() {
        editor.BtnShow135();
    }

    tryChangeActive() {
        this.active()
    }
}

export const getXiumiUrl = (stuffId, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/xiumi/getXiumiUrl?stuffId=" + stuffId;
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headerJson,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:synContent", error);
        callBack("");
    })
};

export const synContent = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/xiumi/synContent";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headerJson,
        credentials: 'include',
        body: params
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:synContent", error);
        callBack("");
    })
};

//下载图文
export const downloadCurrentMaterial = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/material/downloadStuff";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headerJson,
        credentials: 'include',
        body: JSON.stringify(params),
    }).then(response => response.blob()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:downloadCurrentMaterial", error);
        callBack("");
    })
};

export const getWordContent = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/word/getContent?";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getWordContent", error);
        callBack("");
    })
};

//一键排版
export const format = (params, callBack) => {
    let url = "/cm-sites-" + applicationName() + "/storyNew/format?";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getWordContent", error);
        callBack("");
    })
};

//获取秀米插件下载链接
export const getXiuMiPlugin = (callBack) => {
    let url = "/cm-sites-" + applicationName() + "/material/getExtension";
    fetch(url, {
        method: 'get',
        cache: 'no-cache',
        headers: headerJson,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getXiuMiPlugin", error);
        callBack("");
    })
};
